skrilla.directive('userActivityStatements', function () {
    return {
        templateUrl: 'directives/userActivityStatements/userActivityStatements.html',
        scope: {
            user: "="
        },
        controller: function ($scope, modalService, cacheService, searchService, currencyService, srefService, adminService, queryService, validationService) {
            $scope.hasRole = adminService.hasRole

            $scope.generate = function () {
                searchService.get(`userActivityStatements/${$scope.user.id}`).then((response) => {
                    $scope.searched = true;
                    $scope.userActivityStatementUrls = response.data;
                    $scope.hasExistingStatements = validationService.isNotEmpty($scope.userActivityStatementUrls);
                });
            }

            $scope.monthYearFormat = function (date) {
                return `${monthNames[new Date(date).getMonth()]}-${new Date(date).getFullYear()}`
            }

            const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sep", "Oct", "Nov", "Dec"];


            $scope.search = function () {
                const request = {
                    ...$scope.query,
                    firstDate: toUTC(new Date($scope.query.firstDate)),
                    lastDate: toUTC(new Date($scope.query.lastDate))
                }
                searchService.get(`userActivityStatements/test/${$scope.user.id}` + queryService.getQueryString(request)).then((response) => {
                    $scope.userActivityStatement = response.data;
                });
            }

            function toUTC(date) {
                date.setMinutes(date.getMinutes() - date.getTimezoneOffset())
                return date
            }

        }
    };
});